import Url from 'url-parse';

export default url => new Url(url).query.split('?').pop();